module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('MarkupForm', {
    attrs: {
      "button-text": "Зарегистрироваться",
      "disabled": _vm.isDisabled || !_vm.agree || !_vm.is_accepted_consent_pdp,
      "messages": _vm.errorMessage
    },
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('template', {
    slot: "buttons"
  }, [(_vm.isEsiaModule) ? _c('div', {
    staticClass: "auth-services"
  }, [_c('EsiaLink', {
    staticClass: "auth-services_btn"
  })], 1) : _vm._e()]), _c('template', {
    slot: "default"
  }, [(_vm.$store.state.regionProfile.regionId > 0) ? _c('section', {
    staticClass: "d-flex flex-column form-signup__wrapper",
    staticStyle: {
      "max-width": "720px"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('p', {
    staticClass: "personal_data_header header_block"
  }, [_vm._v("Личные данные")]), _c('section', {
    staticClass: "d-flex flex-column"
  }, [_c('form-input', {
    staticClass: "parts-form-signup__field personal_data_1_block",
    attrs: {
      "label": "Введите Вашу фамилию (для заполнений договоров и заявлений)",
      "name": "last_name",
      "placeholder": "Например, Иванов",
      "error": _vm.validStateMachine(_vm.$v.lastName.$dirty, _vm.$v.lastName.$invalid),
      "error-text": _vm.getMessage(_vm.$v.lastName),
      "required": true
    },
    on: {
      "focus": function($event) {
        return _vm.$v.lastName.$reset()
      },
      "input": function($event) {
        return _vm.$v.lastName.$reset()
      },
      "blur": function($event) {
        return _vm.$v.lastName.$touch()
      }
    },
    model: {
      value: (_vm.lastName),
      callback: function($$v) {
        _vm.lastName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "lastName"
    }
  }), _c('form-input', {
    staticClass: "parts-form-signup__field personal_data_2_block",
    attrs: {
      "label": "Введите Ваше имя",
      "name": "first_name",
      "placeholder": "Например, Иван",
      "error": _vm.validStateMachine(_vm.$v.firstName.$dirty, _vm.$v.firstName.$invalid),
      "error-text": _vm.getMessage(_vm.$v.firstName),
      "required": true
    },
    on: {
      "focus": function($event) {
        return _vm.$v.firstName.$reset()
      },
      "input": function($event) {
        return _vm.$v.firstName.$reset()
      },
      "blur": function($event) {
        return _vm.$v.firstName.$touch()
      }
    },
    model: {
      value: (_vm.firstName),
      callback: function($$v) {
        _vm.firstName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "firstName"
    }
  }), _c('form-input', {
    staticClass: "parts-form-signup__field personal_data_3_block mb-10",
    attrs: {
      "label": "Введите Ваше отчество",
      "name": "middle_name",
      "placeholder": "Например, Иванович",
      "error": _vm.validStateMachine(_vm.$v.patroName.$dirty, _vm.$v.patroName.$invalid),
      "error-text": _vm.getMessage(_vm.$v.patroName),
      "required": false
    },
    on: {
      "focus": function($event) {
        return _vm.$v.patroName.$reset()
      },
      "input": function($event) {
        return _vm.$v.patroName.$reset()
      },
      "blur": function($event) {
        return _vm.$v.patroName.$touch()
      }
    },
    model: {
      value: (_vm.patroName),
      callback: function($$v) {
        _vm.patroName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "patroName"
    }
  })], 1)]), _c('section', [_c('p', {
    staticClass: "contact_details_header header_block"
  }, [_vm._v("Контактные данные")]), _c('form-input', {
    staticClass: "parts-form-signup__field field_phone contact_details_1_block",
    attrs: {
      "label": "Введите номер мобильного телефона (для связи при обработке заявок)",
      "name": "phone",
      "placeholder": "В формате (926) 575-84-39",
      "error": _vm.validStateMachine(_vm.$v.phone.$dirty, _vm.$v.phone.$invalid),
      "error-text": _vm.getMessage(_vm.$v.phone),
      "mask": _vm.phoneMask,
      "appendPhone": true,
      "required": true
    },
    on: {
      "focus": function($event) {
        return _vm.$v.phone.$reset()
      },
      "input": function($event) {
        return _vm.$v.phone.$reset()
      },
      "blur": function($event) {
        return _vm.$v.phone.$touch()
      }
    },
    model: {
      value: (_vm.phone),
      callback: function($$v) {
        _vm.phone = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "phone"
    }
  }), _c('form-input', {
    staticClass: "parts-form-signup__field contact_details_2_block mb-10",
    attrs: {
      "label": "Введите email (для направления уведомлений)",
      "name": "email",
      "placeholder": "Например, mail@mail.ru",
      "error": _vm.validStateMachine(_vm.$v.email.$dirty, _vm.$v.email.$invalid),
      "error-text": (function () { return (typeof _vm.getMessage(_vm.$v.email) == "string" ? _vm.getMessage(_vm.$v.email) : _vm.getMessage(_vm.$v.email)(_vm.email)); })(),
      "warning": _vm.getWarning,
      "required": true
    },
    on: {
      "focus": function($event) {
        return _vm.$v.email.$reset()
      },
      "input": function($event) {
        _vm.$v.email.$reset(), _vm.resetServerValidation()
      },
      "blur": function($event) {
        return _vm.$v.email.$touch()
      }
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  }, [(_vm.isEmailRegisteredError) ? _c('Link', {
    attrs: {
      "slot": "link",
      "to": {
        hash: "#forget"
      }
    },
    slot: "link"
  }, [_vm._v("Восстановить")]) : _vm._e()], 1)], 1), _c('section', [_c('p', {
    staticClass: "password_header header_block"
  }, [_vm._v("Пароль")]), _c('form-input', {
    staticClass: "parts-form-signup__field password_1_block",
    attrs: {
      "showPasswordEye": true,
      "label": "Выберите пароль (пароль вам пригодится, запомните или запишите его)",
      "name": "password",
      "placeholder": "Выберите пароль",
      "type": "password",
      "error": _vm.validStateMachine(_vm.$v.password.$dirty, _vm.$v.password.$invalid),
      "error-text": _vm.getMessage(_vm.$v.password),
      "required": true
    },
    on: {
      "focus": function($event) {
        return _vm.$v.password.$reset()
      },
      "input": function($event) {
        return _vm.$v.password.$reset()
      },
      "blur": function($event) {
        return _vm.$v.password.$touch()
      }
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "password"
    }
  }), _c('form-input', {
    staticClass: "parts-form-signup__field password_2_block",
    attrs: {
      "label": "Повторите пароль",
      "showPasswordEye": true,
      "name": "passwordConfirm",
      "placeholder": "Повторите пароль",
      "type": "password",
      "error": _vm.errorsObject.passwordConfirm,
      "error-text": _vm.errorsText.passwordConfirm || "Пароли не совпадают",
      "v": _vm.$v.passwordConfirm,
      "required": true
    },
    on: {
      "focus": function($event) {
        return _vm.$v.password.$reset()
      },
      "input": function($event) {
        return _vm.$v.password.$reset()
      },
      "blur": function($event) {
        return _vm.$v.password.$touch()
      }
    },
    model: {
      value: (_vm.passwordConfirm),
      callback: function($$v) {
        _vm.passwordConfirm = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "passwordConfirm"
    }
  }), _c('form-checkbox', {
    staticClass: "password_3_block",
    attrs: {
      "name": "agree"
    },
    model: {
      value: (_vm.agree),
      callback: function($$v) {
        _vm.agree = $$v
      },
      expression: "agree"
    }
  }, [_c('template', {
    slot: "special"
  }, [_vm._v("Я ознакомлен и выражаю согласие с "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$store.state.regionProfile.privacyPolicyFileUrl
    }
  }, [_vm._v("политикой конфиденциальности и пользовательским соглашением*")])])], 2), _c('form-checkbox', {
    staticClass: "password_3_block",
    attrs: {
      "name": "is_accepted_consent_pdp"
    },
    model: {
      value: (_vm.is_accepted_consent_pdp),
      callback: function($$v) {
        _vm.is_accepted_consent_pdp = $$v
      },
      expression: "is_accepted_consent_pdp"
    }
  }, [_c('template', {
    slot: "special"
  }, [_vm._v("Я выражаю "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.$store.state.regionProfile.consentPdpFileUrl
    }
  }, [_vm._v("согласие на обработку моих персональных данных*")])])], 2)], 1)]) : _c('div', {
    staticClass: "form-signup__wrapper"
  }, [_vm._v("Регистрация на Портале Центра опережающей профессиональной подготовки временно недоступна в связи с проведением технических работ по настройке Портала")])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c98e0320","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/default/popup/forms/signup/ViewDefaultPopupFormSignup.vue
// module id = acdff3c4d658cab99dea
// module chunks = 89